import Repository from '@/repositories/RepositoryFactory';
import ApiState from "../../enums/APISTATE";

const holidayRepository = Repository.get('holidayRepository');

export default ({
    namespaced: true,
    state: {
      holidays: [],
      holidaysApiState: ApiState.INIT,
      chosenHoliday: {},
      sidebarOpen: false
    },
    mutations: {
      setHolidaysApiState: (state, apiState) => {
        state.holidaysApiState = apiState;
      },
      setHolidays(state, response) {
        const { data } = response;
        state.holidays = data;
        state.holidaysApiState = ApiState.LOADED;
      },
      initialized(state, { holidays }) {
        state.holidays = holidays;
      },
      setChosenHoliday(state, holiday){
        state.chosenHoliday = holiday;
      },
      setSidebarOpen(state, sidebarOpen){
        state.sidebarOpen = sidebarOpen;
      }
    },
    actions: {
      async getHolidays({ commit }) {
        commit('setHolidaysApiState', ApiState.LOADING);
        try {
          commit('setHolidays', await holidayRepository.getAll());
        }
        catch (error) {
          console.error(error);
          commit('setHolidaysApiState', ApiState.ERROR);
        }
      },
      setChosenHoliday({commit}, holiday){
        commit("setChosenHoliday", holiday)
        commit("setSidebarOpen", true);
      },
      closeSidebar({commit}){
        commit("setSidebarOpen", false);
      },
      async updateHoliday({commit, state}){
        commit("setHolidaysApiState", ApiState.LOADING);
        try{
          await holidayRepository.update(state.chosenHoliday)
          commit("setHolidays", await holidayRepository.getAll())
          commit("setSidebarOpen", false)
          commit("setHolidaysApiState", ApiState.LOADED);
        }catch(error){
          console.error(error)
          commit("setHolidaysApiState", ApiState.ERROR)
        }
      }
    },
    getters: {
      holidaysApiState(state) {
        return state.holidaysApiState;
      },
      holidays(state) {
        return state.holidays;
      },
      chosenHoliday: (state) => {return state.chosenHoliday},
      sidebarOpen: (state) => {return state.sidebarOpen}
    }
  });